import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilderComponent } from './form-builder.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { NgxTippyModule } from 'ngx-tippy-wrapper';
import { SharedModule } from 'app/shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { LineItemPickerModule } from '../line-item-picker/line-item-picker.module';
import { FormBuilderService } from 'app/core/services/form-builder/form-builder.service';



@NgModule({
  declarations: [
    FormBuilderComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatFormFieldModule,
    NgxMatTimepickerModule,
    LineItemPickerModule,
    MatSelectModule,
    NgxTippyModule,
    MatMenuModule,
    MatDialogModule
  ],
  exports:[
    FormBuilderComponent
  ],
  providers: [
    FormBuilderService
  ]
})
export class FormBuilderModule { }
